import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[] | null | undefined, searchText: string | null | undefined): any[] {
    if (!items || !searchText?.trim()) {
      return items ?? [];
    }

    const query = searchText.trim().toLocaleLowerCase();

    return items.filter(item => this.matches(item, query));
  }

  private matches(value: unknown, query: string): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      return String(value).toLocaleLowerCase().includes(query);
    }

    if (Array.isArray(value)) {
      return value.some(entry => this.matches(entry, query));
    }

    if (typeof value === 'object') {
      return Object.values(value as Record<string, unknown>)
        .some(entry => this.matches(entry, query));
    }

    return false;
  }
}
